module.exports = __webpack_public_path__ + "static/img/logo_white_yunqi.bc24d9c5.png";